export const filtrarRecepcionesPorMateriaPrima = (
    recepciones,
    materiaPrimaId,
) => {
    if (!materiaPrimaId) return recepciones;

    return recepciones.filter(
        (recepcion) =>
            recepcion.materia_prima &&
            recepcion.materia_prima.id === materiaPrimaId,
    );
};

export const getMateriaPrimaNombre = (recepciones, materiaPrimaId) => {
    if (!recepciones || recepciones.length === 0) return "";

    const recepcionConMateriaPrima = recepciones.find(
        (recepcion) =>
            recepcion.materia_prima &&
            recepcion.materia_prima.id === materiaPrimaId,
    );

    return recepcionConMateriaPrima && recepcionConMateriaPrima.materia_prima
        ? recepcionConMateriaPrima.materia_prima.nombre
        : "";
}
